import Vue from 'vue';
import Router from 'vue-router';
import QuickStart from '../components/QuickStart';
import Login from '../components/Login';
import AdminSlots from '../components/AdminSlots';
import ConfigureSlots from '../components/ConfigureSlots';
import CustomerSlots from '../components/CustomerSlots';
import settingsClickCollect from '../components/settingsClickCollect';
import ClickCollectOrders from '../components/ClickCollectOrders';
import ImHere from '../components/ImHere';
import Reports from '../components/Reports';

import store from '../store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
  routes: [
    {
		path: '/',
		name: 'admin',
		component: AdminSlots,
	},
    {
		path: '/quickStart/:sectoken/:storeId/:subscriptionType',
		props: true,
		name: 'quickStart',
		component: QuickStart,

	},
    {
		path: '/adminSlots',
		name: 'AdminSlots',
		component: AdminSlots,
	},
    {
		path: '/adminSlots/:storeId',
		props: true,
		name: 'login',
		component: AdminSlots
	},
    {
		path: '/orderCollect/:sectoken/:storeId/:subscriptionType',
		props: true,
		name: 'orderCollect',
		component: Login
	},
    {
      path: '/configureSlots',
      name: 'ConfigureSlots',
      component: ConfigureSlots,
	}, 
    {
      path: '/customerSlots',
      name: 'CustomerSlots',
      component: CustomerSlots,
	},
    {
      path: '/ccsettings',
      name: 'settingsClickCollect',
      component: settingsClickCollect,
	},
    {
      path: '/manageOrders',
      name: 'ClickCollectOrders',
      component: ClickCollectOrders,
	},
    {
		path: '/imHere/:orderId/:pin',
		props: true,
		name: 'imHere',
		component: ImHere,
	},
    {
		path: '/reports',
		props: true,
		name: 'reports',
		component: Reports,
	}
  ],
});

router.beforeEach((to, from, next) => {
	if(to.name != "imHere")
	{
		let redirectURL = ''
		switch(window.location.host)
		{		
			case 'clickandcollect.scanandget-development.co.uk':
			redirectURL = 'https://www.scanandget-development.co.uk/qr-admin/login.php';
			break;
			case 'clickandcollect.scanandget-staging.co.uk':
			redirectURL = 'https://www.scanandget-staging.co.uk/qr-admin/login.php';
			break;
			case 'clickandcollect.scanandget.co.uk':
			redirectURL = 'https://www.scanandget.co.uk/qr-admin/login.php';
			break;
			default:
			redirectURL = 'http://localhost/scanandget/public_html/qr-admin/login.php';
			break;
		}
		
		console.log(redirectURL);
		
		if(!store.state.loggedIn && to.name === 'orderCollect' || !store.state.loggedIn && to.name === 'quickStart')
		{
			console.log(to)
			let payload = [
				{sectoken: to.params.sectoken },
				{storeId: to.params.storeId},
				{loggedIn: false},
				{subscriptionType : to.params.subscriptionType}			
			]
			
			//Make an api call to get the stores settings and update the vuex store state	
			store.dispatch("logIn", payload).then(() => {
			//compare the passed secToken with the one obtained from the api call and updated to the stores settings
			if(to.params.sectoken === store.state.settings.secToken)
			{
				next()				
			}
			else 
			{
				//console.log(to.params.sectoken)
				//console.log(store.state.settings.secToken)
				window.location.href = (redirectURL)
			}
			});
		
		}
		else if(!store.state.loggedIn)
		{
			//	console.log(to)
			//	console.log(store.state)
			window.location.href = (redirectURL)
		}
		else if(store.state.loggedIn)
		{		
			if(to.name === 'orderCollect')
			{
			//	console.log("Loging in and getting settings again after quickstart")
				let payload = [
					{sectoken: to.params.sectoken },
					{storeId: to.params.storeId},
					{loggedIn: true},
					{subscriptionType : to.params.subscriptionType}
				]
				store.dispatch("logIn", payload)	
				next()				
			}
			else
			{
			//	console.log("A logged in route navigation")
			//	console.log(to)
				next()
			}
		}
		else 
		{
			window.location.href = (redirectURL)
		}
	}
	else
	{
		next()
	}
})


export default router;